import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { VIDEO_ACCEPT } from "../../utils/mediaTypes";

// File row under the player in the video edit dialogs: swap the file on an existing video, or undo the swap.
export default function ReplaceVideoBar({ currentUrl, newFile, onPick, onUndo, error }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const currentName = (currentUrl || "").split("/").pop().split("?")[0];

  return (
    <div className="tw-w-full tw-max-w-[640px] tw-mx-auto tw-flex tw-flex-col tw-gap-2">
      <div className={`tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-3 tw-p-4 tw-rounded-[10px] tw-border tw-border-solid ${newFile ? "tw-border-[#FF43A7] tw-bg-[#FF43A7]/10" : "tw-border-[#5A3F49]/50 tw-bg-[#1E0039]"}`}>
        <div className="tw-flex tw-flex-col tw-gap-0.5 tw-min-w-0">
          <span className="tw-text-white tw-text-sm tw-font-semibold tw-truncate">{newFile ? newFile.name : currentName}</span>
          <span className="tw-text-[#E2BDC9] tw-text-xs">
            {newFile ? t("Replaces the current file when you save") : t("Current file")}
          </span>
        </div>
        <div className="tw-flex tw-gap-2 tw-shrink-0">
          {newFile && (
            <button
              type="button"
              onClick={onUndo}
              className="tw-flex-1 md:tw-flex-none tw-min-h-[44px] tw-px-5 tw-bg-transparent tw-border tw-border-solid tw-border-[#5A3F49] tw-rounded-full tw-text-[#E2BDC9] tw-font-['Space_Grotesk'] tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest hover:tw-text-white tw-cursor-pointer"
            >
              {t("Undo")}
            </button>
          )}
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="tw-flex-1 md:tw-flex-none tw-flex tw-items-center tw-justify-center tw-gap-2 tw-min-h-[44px] tw-px-5 tw-bg-[#42295C] hover:tw-bg-[#5A3F49] tw-border-2 tw-border-solid tw-border-[#FF43A7] tw-rounded-full tw-text-white tw-font-['Space_Grotesk'] tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-cursor-pointer"
          >
            <FontAwesomeIcon icon={faRotateRight} className="tw-text-[#FF43A7]" />
            {t("Replace video")}
          </button>
        </div>
        <input
          type="file"
          ref={inputRef}
          hidden
          accept={VIDEO_ACCEPT}
          onChange={(e) => {
            const file = e.target.files[0];
            e.target.value = ""; // so picking the same file again still fires onChange
            if (file) onPick(file);
          }}
        />
      </div>
      {error && <span className="tw-text-red-400 tw-text-xs tw-font-bold tw-px-1">{error}</span>}
    </div>
  );
}
